import { Reducer } from 'redux';
import { update } from '../helpers/immutabilityHelper'
import * as Dtos from '../dtos/Tmd.dtos';

import {
    ACTION_TRIALITEMTEMPLATE_LOAD,
    ACTION_TRIALITEMTEMPLATE_LOAD_BY_ID,
    ACTION_TRIALITEMTEMPLATE_LOAD_FAILURE,
    ACTION_TRIALITEMTEMPLATE_LOAD_SUCCESS,

    ACTION_TRIALITEMTEMPLATE_SAVE,
    ACTION_TRIALITEMTEMPLATE_SAVE_SUCCESS,
    ACTION_TRIALITEMTEMPLATE_SAVE_FAILURE,

    ACTION_TRIALITEMTEMPLATE_CREATE,
    ACTION_TRIALITEMTEMPLATE_CREATE_SUCCESS,
    ACTION_TRIALITEMTEMPLATE_CREATE_FAILURE,

    ACTION_TRIALITEMTEMPLATE_VALIDATE,
    ACTION_TRIALITEMTEMPLATE_VALIDATE_SUCCESS,
    ACTION_TRIALITEMTEMPLATE_VALIDATE_FAILURE,

    ACTION_TRIALITEMTEMPLATE_CLEAR,
    ACTION_TRIALITEMTEMPLATES_FILTER,

    TrialItemTemplateAction
} from '../actions/trialItemTemplate';
import { RequestState } from "../enumerations/RequestState";
import { IRequestState, IFormFilter } from "./index";
import { updateFailureIndexToId } from "../helpers/formErrorHelper";

export interface ITrialItemTemplateState {
    formData: Dtos.TrialItemTemplate | Dtos.TrialItemTemplate[],
    formDataTrialed: Dtos.Category[];
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    validationFailures: Dtos.ResponseError[];
    lookups: Dtos.Lookup[],
    loadState: IRequestState;
    saveState: IRequestState;
    updateState: IRequestState;
    createState: IRequestState;
    validateState: IRequestState;
    formFilter: IFormFilter;
    formFilteredData: Dtos.TrialItemTemplate[];
    formFilteredDataGrouped: Dtos.Category[];
}

const initialState: ITrialItemTemplateState = {
    formData: undefined,
    formDataTrialed: undefined,
    formState: undefined,
    formProperties: undefined,
    validationFailures: undefined,
    lookups: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState,
    saveState: {
        status: RequestState.None
    } as IRequestState,
    updateState: {
        status: RequestState.None
    } as IRequestState,
    createState: {
        status: RequestState.None
    } as IRequestState,
    validateState: {
        status: RequestState.None
    } as IRequestState,
    formFilter: {
        search: "",
        showInActive: false
    },
    formFilteredData: [],
    formFilteredDataGrouped: undefined,
};


function loading(state: ITrialItemTemplateState, _isLoading: boolean): ITrialItemTemplateState {
    const newState: ITrialItemTemplateState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(
    state: ITrialItemTemplateState,
    formData: Dtos.TrialItemTemplate | Dtos.TrialItemTemplate[],
    formDataTrialed: Dtos.Category[],
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[],
    responseStatus: Dtos.ResponseStatus
): ITrialItemTemplateState {
    const newState: ITrialItemTemplateState = update(state, {
        formData: {
            $set: formData
        },
        formDataTrialed: {
            $set: formDataTrialed
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return filter(newState, state.formFilter);
}

function filter(state: ITrialItemTemplateState, formFilter: IFormFilter): ITrialItemTemplateState {

    const formData: Dtos.TrialItemTemplate[] | undefined =
        state.formData instanceof Array ?
            state.formData :
            undefined;

    const formFilteredData = formData ? formData.filter(p => (p.active == true || formFilter.showInActive) &&
        (formFilter.search == "" || p.name.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1)) : undefined;

    let formFilteredDataGrouped = [];
    if (state.formDataTrialed) {
        for (var i = 0; i < state.formDataTrialed.length; i++) {
            const filteredCategoryItems =
                state.formDataTrialed[i].trialItemTemplates.filter(p => (p.active == true || formFilter.showInActive) &&
                    (formFilter.search == "" ||
                        (p.name != undefined && p.name.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1) ||
                        (p.description != undefined && p.description.toLowerCase().indexOf(formFilter.search.toLowerCase()) > -1)
                    ));
            if (filteredCategoryItems.length > 0) {
                formFilteredDataGrouped.push({
                    ...state.formDataTrialed[i],
                    trialItemTemplates: filteredCategoryItems
                });
            }
        }
    }

    const newState: ITrialItemTemplateState = update(state, {
        formFilter: {
            $set: formFilter
        },
        formFilteredData: {
            $set: formFilteredData
        },
        formFilteredDataGrouped: {
            $set: formFilteredDataGrouped
        }
    });

    return newState;
}

function loadFailure(state: ITrialItemTemplateState, responseStatus: Dtos.ResponseStatus): ITrialItemTemplateState {
    const newState: ITrialItemTemplateState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors
            } as IRequestState
        }
    });

    return newState;
}

function clear(state: ITrialItemTemplateState, propertiesToClear?: string[]): ITrialItemTemplateState {

    if (!propertiesToClear) {
        const newState: ITrialItemTemplateState = update(initialState, {});
        return newState;
    }

    let stateModifier: any = {};

    propertiesToClear.forEach(propertyToClear => {
        stateModifier[propertyToClear] = { $set: initialState[propertyToClear] }
    });

    const newState = update(state, stateModifier);

    return newState;
}

function saving(state: ITrialItemTemplateState, _isSaving: boolean): ITrialItemTemplateState {
    const newState: ITrialItemTemplateState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function saveSuccess(
    state: ITrialItemTemplateState,
    formData: Dtos.TrialItemTemplate | Dtos.TrialItemTemplate[],
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): ITrialItemTemplateState {
    const newState: ITrialItemTemplateState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        saveState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function saveFailure(state: ITrialItemTemplateState, responseStatus: Dtos.ResponseStatus): ITrialItemTemplateState {
    const newState: ITrialItemTemplateState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

function creating(state: ITrialItemTemplateState, _isCreating: boolean): ITrialItemTemplateState {
    const newState: ITrialItemTemplateState = update(state, {
        createState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function createSuccess(
    state: ITrialItemTemplateState,
    formData: Dtos.TrialItemTemplate,
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
): ITrialItemTemplateState {
    const newState: ITrialItemTemplateState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        createState: {
            $set: {
                status: RequestState.Success
            } as IRequestState
        }
    });

    return newState;
}

function createFailure(state: ITrialItemTemplateState, responseStatus: Dtos.ResponseStatus): ITrialItemTemplateState {
    const newState: ITrialItemTemplateState = update(state, {
        createState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors
            } as IRequestState
        }
    });

    return newState;
}

function validating(state: ITrialItemTemplateState, _isValidating: boolean): ITrialItemTemplateState {
    const newState: ITrialItemTemplateState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function validateSuccess(
    state: ITrialItemTemplateState,
    formData: Dtos.TrialItemTemplate,
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus
): ITrialItemTemplateState {
    const newState: ITrialItemTemplateState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        validateState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function validateFailure(state: ITrialItemTemplateState, responseStatus: Dtos.ResponseStatus): ITrialItemTemplateState {
    const newState: ITrialItemTemplateState = update(state, {
        validateState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus?.errorCode,
                errorMessage: responseStatus?.message,
                errors: responseStatus?.errors,
                meta: responseStatus.meta
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, state.formData) : undefined
        }
    });

    return newState;
}

const TrialItemTemplateReducer: Reducer<ITrialItemTemplateState> = (state: ITrialItemTemplateState = initialState, action: TrialItemTemplateAction) => {
    switch (action.type) {
        case ACTION_TRIALITEMTEMPLATE_LOAD:
        case ACTION_TRIALITEMTEMPLATE_LOAD_BY_ID:
            return loading(state, true);
        case ACTION_TRIALITEMTEMPLATE_LOAD_SUCCESS:
            return loadSuccess(state, action.formData, action.formDataTrialed, action.formState, action.formProperties, action.lookups, action.responseStatus);
        case ACTION_TRIALITEMTEMPLATE_LOAD_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_TRIALITEMTEMPLATE_CLEAR:
            return clear(state, action.propertiesToClear);
        case ACTION_TRIALITEMTEMPLATE_SAVE:
            return saving(state, true);
        case ACTION_TRIALITEMTEMPLATE_SAVE_SUCCESS:
            return saveSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_TRIALITEMTEMPLATE_SAVE_FAILURE:
            return saveFailure(state, action.responseStatus);
        case ACTION_TRIALITEMTEMPLATE_CREATE:
            return creating(state, true);
        case ACTION_TRIALITEMTEMPLATE_CREATE_SUCCESS:
            return createSuccess(state, action.formData, action.formState, action.formProperties, action.lookups);
        case ACTION_TRIALITEMTEMPLATE_CREATE_FAILURE:
            return createFailure(state, action.responseStatus);
        case ACTION_TRIALITEMTEMPLATE_VALIDATE:
            return validating(state, true);
        case ACTION_TRIALITEMTEMPLATE_VALIDATE_SUCCESS:
            return validateSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_TRIALITEMTEMPLATE_VALIDATE_FAILURE:
            return validateFailure(state, action.responseStatus);
        case ACTION_TRIALITEMTEMPLATES_FILTER:
            return filter(state, action.formFilter);
    }

    return state;
}

export default TrialItemTemplateReducer;